import { Fade } from "react-awesome-reveal";
import "./hero-text.scss";

type HeroTextPropsT = {
  title: string;
  text: string;
};
const HeroText = ({ title, text }: HeroTextPropsT) => {
  return (
    <section className="hero-text">
      <Fade
        direction="up"
        duration={800}
        triggerOnce
        style={{ display: "flex", justifyContent: "center" }}
      >
        <h1 className="hero-text__title">{title}</h1>
      </Fade>
      <Fade
        direction="up"
        duration={1000}
        delay={200}
        triggerOnce
        style={{ display: "flex", justifyContent: "center" }}
      >
        <p className="hero-text__text">{text}</p>
      </Fade>
    </section>
  );
};

export default HeroText;
